import { render } from "./StandingsComponent.vue?vue&type=template&id=e24da7e2&scoped=true"
import script from "./StandingsComponent.vue?vue&type=script&lang=js"
export * from "./StandingsComponent.vue?vue&type=script&lang=js"

import "./StandingsComponent.vue?vue&type=style&index=0&id=e24da7e2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e24da7e2"]])

export default __exports__